import React from 'react';
import { Box } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import HamburgerSVG from '€components/svgs/hamburger.svg';
import BrandLogo from '../../assets/loan-logo-ai-lr.png';
export interface DashboardSidebarHeadProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DashboardSideBarNavHead: React.FC<DashboardSidebarHeadProps> = ({ open, setOpen }) => {
    const classes = useStyles();

    return (
        <div className={classes.navHead}>
            <Box
                className={clsx(classes.logo, {
                    [classes.hide]: !open,
                })}
            >
                <img src={BrandLogo} height="70" />
            </Box>
            <IconButton
                onClick={() => setOpen(false)}
                className={clsx({
                    [classes.hide]: !open,
                })}
            >
                <ChevronLeftIcon className={classes.leftChevron} />
            </IconButton>
            <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => setOpen(true)}
                edge="start"
                className={clsx(classes.menuButton, {
                    [classes.hide]: open,
                })}
            >
                <HamburgerSVG />
            </IconButton>
        </div>
    );
};

export default DashboardSideBarNavHead;
